<ng-container mcWrittenContentAnchorClickListener (anchorClick)="writtenContentLinkAction.emit($event)">
  <h4 class="FocusBox__header">Focus box</h4>
  <h4 class="FocusBox__title" data-hook="focusbox-title">{{ value().title }}</h4>
  <div class="FocusBox__body" [innerHtml]="value().body | updateLink | safeHtml" data-hook="focusbox-body"></div>
</ng-container>
